import { MaxKeywordLength } from "./consts";

export function sanitizeKeyword(keyword?: string) {
  return keyword?.trim()?.slice(0, MaxKeywordLength) ?? "";
}
